// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"380":"3e5df91a","403":"1ef2f2e8","453":"71a8e6bf","708":"f4ee52f8","807":"d56dcd4a"}[chunkId] + ".css";
};